export default "__VITE_ASSET__DRFUFcQL__"